import * as React from 'react';

import ZoomIcon from '../../../../../assets/images/zoom.svg';

interface IProps {
    onClick: () => void;
}

export const Zoom: React.FC<IProps> = ({ onClick }) => (
    <div
        className="closeIcon"
    >
        <img
            src={ZoomIcon}
            onClick={onClick}
            alt=""
        />
    </div>
);
